import { useParams, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const AdminEnqMenu = () => {
    const location = useLocation();
    const path = location.pathname;
    const schoolSlugs = JSON.parse(localStorage.getItem("school_slugs")) || [];
    const firstSlug = schoolSlugs.length > 0 ? schoolSlugs[0] : "";
    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4 position-fixed">
            {/* Brand Logo */}
            <NavLink to="/admin/enquiry-dashboard/" className="brand-link text-center">
                <span className="brand-text font-weight-light ml-2">TIGPS</span>
            </NavLink>

            {/* Sidebar */}
            <div className="sidebar">
                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                    >
                        {/* Dashboard */}
                        <li className="nav-item">
                            <NavLink
                                to={`/admin/enquiry-dashboard/${firstSlug}`}
                                end
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p className="admin-menu-p">Dashboard</p>
                            </NavLink>
                        </li>
                        {/* Dashboard */}
                        <li className="nav-item">
                            <NavLink
                                to={`/admin/enquiry-detail/${firstSlug}`}
                                end
                                className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                }
                            >
                                <i className="nav-icon fas fa-list-alt" />
                                <p className="admin-menu-p">Enquiry list</p>
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default AdminEnqMenu;
